import createChainedFunction from "./createChainedFunction";

describe("createChainedFunction", () => {
  it("should handle createChainedFunction", () => {
    const one = (): string => {
      return "one";
    };

    const two = (): string => {
      return "two";
    };

    const test = createChainedFunction(one, two);
    const test2 = createChainedFunction(null);
    if (test) {
      expect(test()).toEqual(undefined);
    }
    if (test2) {
      expect(test2()).toEqual(undefined);
    }
  });
});
